import {combineReducers} from 'redux'
import auth from './auth'
import elements from "../Views/elements/store";

const rootReducer = (asyncReducers) => (state, action) => (
  combineReducers({
    auth,
    elements,
    ...asyncReducers,
  })
)(state, action)

export default rootReducer
